import api from '@/plugins/axios';
import { mountUrl } from './helper';

const BASE_PATH = 'budget_payment_conditions';

export default {
  async create(body) {
    const url = mountUrl(`/${BASE_PATH}`);
    return api.post(url, body);
  },
  async inactivate(budgetId, paymentConditionId) {
    const url = mountUrl(`/${BASE_PATH}/${budgetId}/${paymentConditionId}`);
    return api.delete(url);
  }
};
